var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('h1',{staticClass:"text-center text-warning text-2xl font-bold"},[_vm._v(_vm._s(_vm.title))]),_c('br'),_c('img',{staticClass:"w-full",attrs:{"src":"https://mir-s3-cdn-cf.behance.net/project_modules/disp/afb8cb36197347.5713616457ee5.gif"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }